Namespace 'Customer.Ticket'

class Customer.Ticket.StatusChangeBox extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/status_change_box']
  className: 'status-change-box'

  initialize: ({@event}) ->
    @model = @event

  render: ->
    @$el.html(@template({
      iconClass: @_icon(),
      description: @event.message(),
      date: @_formattedDate()
    }))
    @_setClass()
    @_iconTag().html(@_inAttentionIconView().render().el) if @event.isAssigned()
    @_iconTag().html(@_pendingIconView().render().el) if @event.isUnassigned()
    @

  externalIdClass: ->
    ''

  _setClass: ->
    cssClass = {
      'Pending': 'pending',
      'Not Assigned': 'not-assigned',
      'Reopen': 'not-assigned',
      'Closed': 'closed',
      'Assigned': 'assigned'
    }[@event.get('status')]
    @$el.addClass(cssClass)

  _formattedDate: ->
    Date.create(@event.created_at()).format('MMM DD HH:mm')

  _icon: ->
    {
      'Pending': 'fa-clock-o',
      'Not Assigned': '',
      'Reopen': 'fa-times-circle',
      'Closed': 'fa-check-circle',
      'Assigned': ''
    }[@event.get('status')]

  _iconTag: ->
    @$('.status-change-box__icon')

  _pendingIconView: ->
    new Common.SvgIconView({
      svgPath: 'icons/status-not-assigned.svg'
      svgId: 'status-not-assigned'
      iconClass: ''
    })

  _inAttentionIconView: ->
    new Common.SvgIconView({
      svgPath: 'icons/status-assigned.svg'
      svgId: 'status-assigned'
      iconClass: ''
    })
